import React from 'react';
import PropTypes from 'prop-types';
import { Consumer } from '../../../../_views/global_context';
import { replaceSpacesWithDashes } from '../../../../_modules/string/replace_spaces_with_dashes';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';
import LazyLoad from 'react-lazyload';
import { replaceWithOptionalManufacturerTranslation }
    from '../../../../_modules/translation/replace_with_optional_manufacturer_translation';

const generateTextualClassNames = modifier => generateClassName({
    'brand-logo': true,
    'brand-logo--image': true,
    ['brand-logo--' + modifier]: true,
})();

export const Image = ( { manufacturer, staticUrl, manufacturerImage }) => {
    const manufacturerImageFileName = manufacturer.replace(/-| /, '_').concat('.jpg');
    const translatedManufacturer = replaceWithOptionalManufacturerTranslation(manufacturer);
    const classNameModifier = replaceSpacesWithDashes(translatedManufacturer).toLowerCase();
    const classNames = generateTextualClassNames(classNameModifier);

    return (
        <span className={classNames}>
            <Consumer>
                {
                    globals => (
                        <LazyLoad width={100} once>
                            <img
                                className="brand-logo__image"
                                alt={translatedManufacturer}
                                src={manufacturerImage ||
                                    globals.staticUrl +
                                    'images/manufacturer/' +
                                    manufacturerImageFileName.toLowerCase()
                                }
                            />
                        </LazyLoad>
                    )
                }
            </Consumer>
        </span>
    );
};

Image.propTypes = {
    manufacturer: PropTypes.string.isRequired,
};
